import { Link } from "react-router-dom";
import { useLogo } from "@/context/AssetsContext";
import { useSiteConfig } from "@/context/SiteConfigContext";

const COLS = [
  { title: "Product", links: [["How It Works", "#how-it-works"], ["Features", "#features"], ["Services", "#services"], ["Launch Cities", "#launch-cities"]] },
  { title: "Company", links: [["For Providers", "#providers"], ["FAQ", "#faq"], ["Privacy Policy", "#"], ["Terms of Service", "#"]] },
];

const SOCIALS = ["TikTok", "Instagram", "Facebook", "X"];

export default function Footer() {
  const logo = useLogo();
  const { config } = useSiteConfig();
  const t = config.t.footer;
  return (
    <footer className="border-t border-black/5 bg-[#0A0A0A] py-16 text-white" data-testid="footer">
      <div className="mx-auto max-w-6xl px-6">
        <div className="grid gap-10 md:grid-cols-[1.5fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <img src={logo} alt="SOSConnect AI" className="h-10 w-10 object-contain" />
              <span className="text-lg font-bold tracking-tight">SOSConnect <span className="text-brand">AI</span></span>
            </div>
            <p className="mt-4 max-w-xs text-2xl font-bold tracking-tighter text-white/90">{t.tagline}</p>
            <div className="mt-6 flex gap-2">
              {SOCIALS.map((s) => (
                <a key={s} href="#" className="rounded-full border border-white/10 px-4 py-2 text-xs font-medium text-white/70 transition-colors hover:bg-white/5 hover:text-white" data-testid={`social-${s.toLowerCase()}`}>{s}</a>
              ))}
            </div>
          </div>
          {COLS.map((c) => (
            <div key={c.title}>
              <p className="text-xs font-bold uppercase tracking-wider text-white/40">{c.title}</p>
              <ul className="mt-4 space-y-3">
                {c.links.map(([label, href]) => (
                  <li key={label}>
                    {href.startsWith("#")
                      ? <a href={href} className="text-sm text-white/70 transition-colors hover:text-white">{label}</a>
                      : <span className="text-sm text-white/70">{label}</span>}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-14 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-8 text-sm text-white/40 sm:flex-row">
          <p>{t.copyright}</p>
          <Link to="/admin/login" className="text-white/30 transition-colors hover:text-white/60" data-testid="footer-admin-link">Admin</Link>
        </div>
      </div>
    </footer>
  );
}
